import React, { useEffect, useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import { useNavigate, useParams } from "react-router-dom";

import { getInterviews } from "../../services/Interviews/interviewService";

export default function NewSideBar() {
  const getNavLinks = (interview) => [
    {
      label: "Dashboard",
      path: `/interviews/${interview.uuid}`,
    },
    {
      label: "Interview Details",
      path: `/interviews/${interview.uuid}/edit`,
    },
    {
      label: "Session List",
      path: `/interviews/${interview.uuid}/sessions`,
    },
    {
      label: "View Reports",
      path: `/interviews/${interview.uuid}/student-responses`,
    },
  ];

  const [interviews, setInterviews] = useState([]);
  const [openSections, setOpenSections] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { uuid: currentUuid } = useParams();

  useEffect(() => {
    const controller = new AbortController();
    setIsLoading(true);
    getInterviews({ signal: controller.signal })
      .then((res) => {
        setInterviews(Array.isArray(res?.results) ? res.results : Array.isArray(res) ? res : []);
      })
      .catch(() => {
        console.error("Failed to load interviews");
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      });

    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (currentUuid) {
      setOpenSections({ [currentUuid]: true });
    }
  }, [currentUuid]);

  const toggle = (u) => setOpenSections((o) => ({ ...o, [u]: !o[u] }));

  return (
    <div className="w-64 bg-blue-950 dark:bg-gray-900 p-4 h-full overflow-y-auto border-r border-gray-700">
      <h2 className="mb-4 text-sm font-semibold uppercase text-gray-400">
        Interviews
      </h2>

      {isLoading ? (
        <p className="text-gray-300">Loading...</p>
      ) : (
        interviews.map((interview) => (
          <div key={interview.uuid} className="mb-4">
            <button
              onClick={() => toggle(interview.uuid)}
              className="flex items-center justify-between w-full text-gray-300 hover:text-white group"
            >
              <div className="relative">
                <p className="font-medium text-left">{interview.name}</p>
                <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
              </div>
              {openSections[interview.uuid] ? (
                <ChevronUpIcon className="w-5 h-5 text-gray-400" />
              ) : (
                <ChevronDownIcon className="w-5 h-5 text-gray-400" />
              )}
            </button>

            <div
              className={`transition-all duration-300 ease-in-out overflow-hidden ${
                openSections[interview.uuid]
                  ? "max-h-40 opacity-100"
                  : "max-h-0 opacity-0"
              }`}
            >
              <ul className="mt-2 ml-4 border-l-2 border-gray-600">
                {getNavLinks(interview).map(({ label, path }) => (
                  <li key={label}>
                    {path ? (
                      <button
                        onClick={() =>
                          navigate(path, {
                            state: { interviewName: interview.name },
                          })
                        }
                        className="relative block w-full text-left px-2 py-1 text-gray-300 hover:text-white group"
                      >
                        <span>{label}</span>
                        <span className="absolute left-2 bottom-0 h-0.5 w-0 bg-blue-400 transition-all duration-300 group-hover:w-[90%]"></span>
                      </button>
                    ) : (
                      <span className="block w-full text-left px-2 py-1 text-gray-500 cursor-not-allowed">
                        {label}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
